/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

(function($) {

  // Use this variable to set up the common and page specific functions. If you
  // rename this variable, you will also need to rename the namespace below.
  var Sage = {
    // All pages
    'common': {
      init: function() {
        // JavaScript to be fired on all pages

        // Mobile menu - toggle
        $(document).on("click",".burger-btn", function() {
          if($('#mobileMenu').css( "display" ) !== 'block') {
            $('#mobileMenu').slideDown("medium", function() {
              $('#mobileMenuClose').fadeIn();
            });
          } else {
            $('#mobileMenuClose').hide();
            $('#mobileMenu').slideUp("medium", function() {});
          }
        });

        // Mobile menu - slide up
        $(document).on("click","#mobileMenuClose", function() {
            $('#mobileMenuClose').hide();
            $('#mobileMenu').slideUp("medium", function() {});
        });


        // Banner owl
        $("#banner-header").owlCarousel({
          'singleItem':true,
          'navigation': true,
          'navigationText' : false,
          'pagination': false
        });

        // What we do banner
        $("#banner-body").owlCarousel({        
          'navigation': true,
          'navigationText' : false,
          'items' : 5, 
          'itemsDesktop' : [1000,5],
          'itemsDesktopSmall' : [900,3],
          'itemsTablet': [600,1],
          'itemsMobile' : false,
          'scrollPerPage': true,
          'pagination': true,
          'paginationNumbers': false
        });

        
        // Set the height of the What We Do boxes
        function alignBox() {
          $( "#banner-body .image" ).each(function( index ) {
            var boxWidth = $(this).outerWidth();
            $(this).outerHeight(boxWidth);
          });
        }
        alignBox();

        // Side menu, if parent is active open next menu        
        $( "#sidebarMenu li.hasChildren" ).each(function( index ) {
         
          if($(this).hasClass('active')) {
            $(this).next('ul').fadeIn();
          } else {
            // Side menu, if child is active set menu
            if($(this).next('ul').find('.active').length == 1) {
              $(this).next('ul').fadeIn();
            }
          }

        });

      },
      finalize: function() {
        // JavaScript to be fired on all pages, after page specific JS is fired
      }
    },
    // Home page
    'home': {
      init: function() {
        // JavaScript to be fired on the home page
      },
      finalize: function() {
        // JavaScript to be fired on the home page, after the init JS
      }
    },
    // About us page, note the change from about-us to about_us.
    'about_us': {
      init: function() {
        // JavaScript to be fired on the about us page
      }
    }
  };

  // The routing fires all common scripts, followed by the page specific scripts.
  // Add additional events for more control over timing e.g. a finalize event
  var UTIL = {
    fire: function(func, funcname, args) {
      var fire;
      var namespace = Sage;
      funcname = (funcname === undefined) ? 'init' : funcname;
      fire = func !== '';
      fire = fire && namespace[func];
      fire = fire && typeof namespace[func][funcname] === 'function';

      if (fire) {
        namespace[func][funcname](args);
      }
    },
    loadEvents: function() {
      // Fire common init JS
      UTIL.fire('common');

      // Fire page-specific init JS, and then finalize JS
      $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function(i, classnm) {
        UTIL.fire(classnm);
        UTIL.fire(classnm, 'finalize');
      });

      // Fire common finalize JS
      UTIL.fire('common', 'finalize');
    }
  };

  // Load Events
  $(document).ready(UTIL.loadEvents);

})(jQuery); // Fully reference jQuery after this point.
